import catchAsync from "../../utils/catchAsync";
import httpsCall from "../httpsCall";

export const homeApi = catchAsync(async () => {  
    const data = await httpsCall.get(`page/home-page`);
    return data;
});

export const CategoryApi = catchAsync(async () => {  
    const data = await httpsCall.get(`page/category-list`);
    return data;
});

export const aboutApi = catchAsync(async () => {  
    const data = await httpsCall.get(`page/about-us`);
    return data;
});

export const servicesApi = catchAsync(async () => {  
    const data = await httpsCall.get(`page/our-services`);
    return data;
});

export const recruitApi = catchAsync(async () => {  
    const data = await httpsCall.get(`page/our-recruitment-services`);
    return data;
});

export const imigrationApi = catchAsync(async () => {  
    const data = await httpsCall.get(`page/immigration-services`);
    return data;
});

export const employerApi = catchAsync(async () => {  
    const data = await httpsCall.get(`page/employer`);
    return data;
});

export const jobseekerApi = catchAsync(async () => {  
    const data = await httpsCall.get(`page/jobseeker`);
    return data;
});

export const localAgentApi = catchAsync(async () => {  
    const data = await httpsCall.get(`page/local-agency`);
    return data;
});

export const cntctApi = catchAsync(async () => {  
    const data = await httpsCall.get(`page/contact-us`);
    return data;
});

export const prvcyApi = catchAsync(async () => {  
    const data = await httpsCall.get(`page/privacy-policy`);
    return data;
});

export const termsApi = catchAsync(async () => {  
    const data = await httpsCall.get(`page/terms-and-conditions`);
    return data;
});